function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "a"
}, React.createElement("path", {
  d: "M0 11.34h37.87v4.19H0z"
})), React.createElement("clipPath", {
  id: "b"
}, React.createElement("path", {
  d: "M5.42.14h15.17v14.85H5.42z"
})));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "fill-primary",
  d: "M33.13 12.34a2.06 2.06 0 012.1 2.39l-2.22 15.51a2.86 2.86 0 01-2.76 2.4H7.63a2.86 2.86 0 01-2.76-2.4L2.64 14.73a2.06 2.06 0 012.1-2.39zM9.4 30.46c.46 0 .8-.37.77-.83l-1.04-11.5a.92.92 0 00-.9-.84H6.5c-.46 0-.8.37-.74.83l1.39 11.51c.05.46.47.83.93.83zm5.1 0a.8.8 0 00.81-.83l-.43-11.5a.88.88 0 00-.86-.83h-1.73a.77.77 0 00-.79.83l.79 11.5a.9.9 0 00.89.83zm6.12-12.33a.82.82 0 00-.83-.83h-1.72a.82.82 0 00-.82.83l.18 11.5a.85.85 0 00.84.83h1.32a.85.85 0 00.85-.83zm5.75 0a.78.78 0 00-.78-.83h-1.73a.87.87 0 00-.86.83l-.43 11.5a.8.8 0 00.8.83h1.33a.9.9 0 00.9-.83zm5.75 0a.73.73 0 00-.75-.83h-1.72a.93.93 0 00-.9.83l-1.04 11.5a.76.76 0 00.77.83h1.32c.46 0 .87-.37.93-.83z"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, React.createElement("path", {
  className: "fill-secondary",
  d: "M37.87 13.44c0 1.15-.98 2.1-2.17 2.1H2.18C.98 15.52 0 14.58 0 13.43c0-1.16.98-2.1 2.18-2.1H35.7c1.2 0 2.17.94 2.17 2.1"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", null, React.createElement("g", {
  clipPath: "url(#b)"
}, React.createElement("path", {
  className: "fill-primary",
  d: "M19.02 11.82L7.12.4a.9.9 0 00-1.29.04L5.67.6a.94.94 0 00.04 1.3L17.44 13.2c0 .07-.04.14-.04.21a1.6 1.6 0 003.2 0c0-.87-.71-1.56-1.58-1.58"
})));
var SvgPanierMcGestion = function SvgPanierMcGestion(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 38 33",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPanierMcGestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/panier-mc-gestion.a6c85a7c.svg";
export { ForwardRef as ReactComponent };